<template>
    <div class="w-full">
        <custom-simple-select
            v-model="option"
            label="Tipo de opción extra"
            :options="selectOptions"
            :disabled="!enabled"
            @change="onInput"
        />
    </div>
</template>

<script>
import { productExtraOptionTypesEnum } from "@/common/fields/product-extra-option-types";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "ProductExtraOptionType",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            type: String,
            default: () => "",
            required: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: "",
        $enabledOptions: productExtraOptionTypesEnum
    }),
    computed: {
        selectOptions() {
            return Object.entries(this.$data.$enabledOptions).map(
                ([key, value]) => ({ label: value, value: key })
            );
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onInput(key) {
            this.$emit("change", key);
        },
        setInput(key) {
            this.option = key;
        }
    }
};
</script>
